export default __webpack_public_path__ + "static/media/BULLETS_LLAVE_EN_MANO.1632e4de.png";